export default "__VITE_ASSET__DJC0mf8u__"